import React, { useEffect, useState } from "react";
import "../Landing.scss";
import "../ln.scss";
import QomitaLogo from "../../../assets/img/qomita-logo.jpg";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../../url.json";
import headers from "../../../config/headers";
import { Link } from "react-router-dom";
import { PHONES, EMAIL } from "../LandingHead/LandingHead";
import { useSelector, useDispatch } from "react-redux";
import { aboutReducer } from "../../../Redux/Reducers/About/about";

function LandingFoot({ t }) {
  const [about, setAbout] = useState();
  const [contact, setcontact] = useState();
  const lan = useSelector((state) => state.langReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    axios.get(url.url + "/about", { headers: headers() }).then((res) => {
      setAbout(res.data.data);
      dispatch(aboutReducer(res.data.data));
    });
    axios.get(url.url + "/contact", { headers: headers() }).then((res) => {
      setcontact(res.data.data);
    });
  }, [lan]);

  const socials = (contact || []).filter((c) => c.type != "phone" && c.icon);

  return (
    <footer className="ln ln-footer">
      <div className="ln-wrap">
        <div className="ln-footer__top">
          <div className="ln-footer__brand">
            <Link to="/" className="ln-brand">
              <img
                className="ln-brand__logo"
                src={QomitaLogo}
                alt="Oziq-ovqat mahsulotlari xavfsizligi qo'mitasi"
                width={44}
                height={44}
              />
              <span className="ln-brand__name">
                Vis Nefrit
              </span>
            </Link>
            <p>
              <strong className="ln-footer__committee">{t("ln_committee")}</strong>
              {t("ln_org")}
            </p>
            <p className="ln-footer__contacts">
              {PHONES.map((p) => (
                <a key={p.value} href={`tel:${p.value}`}>{p.label}</a>
              ))}
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </p>
            {socials.length ? (
              <div className="ln-socials">
                {socials.map((s) => (
                  <a key={s.id} href={s.value} target="_blank" rel="noopener noreferrer" title={s.name} aria-label={s.name}>
                    <img src={s.icon} alt="" style={{ filter: "brightness(0) invert(1)" }} />
                  </a>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
          <nav className="ln-footer__nav" aria-label="footer">
            <Link to="/#services">{t("ln_nav_services")}</Link>
            <Link to="/reestr-new">{t("Reestr")}</Link>
            <Link to="/regulations">{t("Regulations")}</Link>
            <Link to="/#news">{t("News")}</Link>
            <Link to="/faq">{t("FAQ")}</Link>
            <Link to="/#contact">{t("Contact")}</Link>
          </nav>
        </div>
        <div className="ln-footer__bottom">
          <span>
            © {new Date().getFullYear()} Vis Nefrit. {t("ln_rights")}
          </span>
          <span>{about?.address}</span>
        </div>
      </div>
    </footer>
  );
}
export default withTranslation()(LandingFoot);
